module.exports = __webpack_public_path__ + "static/media/logo.73624742.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo.svg
// module id = 139
// module chunks = 2